import { apiRequest } from "../api/apiService";

export const fetchPrice = async (symbol) => {
  if (!symbol) return null;

  try {
    const res = await apiRequest({
      url: `https://min-api.cryptocompare.com/data/price?fsym=${symbol}&tsyms=USD`,
      method: "GET",
      auth: false,
    });

    const data = {
      symbol,
      price: res.USD,
    };

    // console.log(`${symbol} price fetched:`, data.price);
    return data;
  } catch (error) {
    console.error(`Error fetching ${symbol} price:`, error);
    return null;
  }
};
